/**
 * First-name display for nav rail / More sheet (matches dashboard welcome source, title case).
 */
export function formatProfileDisplayName({ profile, currentUser } = {}) {
  const first = (profile?.first_name || currentUser?.first_name || '').trim();
  if (first) return first;

  const username = (profile?.username || currentUser?.username || '').trim();
  if (username && username.toLowerCase() !== 'unknown') return username;

  return 'Profile';
}
